export default () => [
  {
    name: 'Male',
    value: 0,
  },
  {
    name: 'Female',
    value: 1,
  },
]
